import React from "react";

function GoalsPage() {
  return (
    <section className="max-w-4xl mx-auto px-4 py-12 font-sans text-slate-800">
      <h1 className="text-4xl font-extrabold text-slate-900 mb-8 text-center">Meine Ziele</h1>

      <div className="mb-12">
        <h2 className="text-2xl font-bold text-slate-900 border-b pb-2 mb-4">Derzeitige Ziele</h2>
        <div className="bg-slate-50 p-6 rounded-xl border border-slate-100 shadow-sm">
          <ul className="list-disc pl-5 space-y-3 text-slate-700 leading-relaxed">
            <li>
              Meinen Fokus auf die Schule richten, um die Abschlusspr&uuml;fungen
              bestm&ouml;glich zu bestehen
            </li>
            <li>
              Vertiefung meiner Kenntnisse in <b>Python f&uuml;r Data Science</b> (z.B.
              Pandas, TensorFlow) sowie in der <b>Full-Stack Softwareentwicklung</b>
            </li>
            <li>
              Entwicklung von Softwareprojekten mit Fokus auf <em>moderne
                Architekturen</em> und die Integration von KI-Komponenten
              in nutzerfreundliche Anwendungen
            </li>
          </ul>
        </div>
      </div>

      <div className="mb-12">
        <h2 className="text-2xl font-bold text-slate-900 border-b pb-2 mb-4">Ziele der n&auml;chsten Jahre</h2>
        <p className="text-slate-700 leading-relaxed">
          F&uuml;r meine berufliche Zukunft strebe ich nach meinem Abschluss zum
          Staatlich gepr&uuml;ften Wirtschaftsinformatiker den direkten <b>Berufseinstieg</b> an.
          Mein Ziel ist eine Position, in der ich meine F&auml;higkeiten sowohl in der{" "}
          <b>Softwareentwicklung</b> als auch in <b>Data Science</b> einbringen und
          weiterentwickeln kann. Ich suche nach Herausforderungen, an denen ich
          praktisch wachsen und einen echten Mehrwert schaffen kann.
        </p>
      </div>

      <div>
        <h2 className="text-2xl font-bold text-slate-900 border-b pb-2 mb-4">Langfristige Ziele</h2>
        <p className="text-slate-700 leading-relaxed">
          Langfristig plane ich, meine Kenntnisse immer weiter auszubauen und
          diese auch an die und deren Anforderungen, vor allem in dieser
          sich schnell entwickelnden Zeit, anzupassen. Ich w&uuml;rde derzeit auch
          ein weiteres Studium zum Master nicht ausschlie&szlig;en. Meine
          langfristigen Ziele beschr&auml;nken sich jedoch nicht nur auf den IT-Bereich, sondern
          umfassen auch die stetige Weiterentwicklung in angrenzenden Bereichen wie
          <em> Sprachkenntnissen, sozialen Kompetenzen oder Projektmanagement</em>.
        </p>
      </div>
    </section>
  );
}

export default GoalsPage;